import { JsonSerializable } from '../shared/jsonSerializable';
import { Product } from '../entity/product';

export class ProductClass extends JsonSerializable {

  code: string;
  label: string;
  products: Product[];

  constructor() {
    super();
    this.code = null;
    this.label = null;
    this.products = new Array<Product>();
  }

  fromJSON(jsonObj: Object) {
    for (var propName in jsonObj) {
      if (this.hasOwnProperty(propName)) {
        if(Array.isArray(jsonObj[propName])){
          for (let i in jsonObj[propName]) {
            if(jsonObj[propName] instanceof Object){
              if (propName == "products") {
                this[propName][i] = new Product();
                this[propName][i].fromJSON(jsonObj[propName][i]);
              }              
            } else {
              this[propName][i] = jsonObj[propName][i];
            }
          }
        } else {
          this[propName] = jsonObj[propName];
        }        
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/entity/product-class.ts